export const isUrl = (urlString: string): boolean => {
  const INPUT_ELEMENT = document.createElement('input');
  INPUT_ELEMENT.type = 'url';
  INPUT_ELEMENT.value = urlString;
  return INPUT_ELEMENT.checkValidity();
}
